import {Link, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";
import {Status} from "../../Status/Status";
import {pravno} from "../../../utils/pravno";

export const CompanySettlement2 = ({ekatte, settlement, municipality, region, bullstat}) => {
    const {year} = useParams();
    const request = requester();
    const [sumDeals, setSumDeals] = useState(0);
    const [sumWhiteSpots, setSumWhiteSpots] = useState(0);
    const [sumRoads, setSumRoads] = useState(0);
    const [sumForDrawing, setSumForDrawing] = useState(null);
    const [sumDrawing, setSumDrawing] = useState(undefined);
    const [sumInitialInfo, setSumInitialInfo] = useState(undefined);

    useEffect(() => {
        Promise.all([
            request.get(`${baseUrl()}/deals/${year}/${ekatte}/${bullstat}/sum`),
            request.get(`${baseUrl()}/others/${year}/${ekatte}/${bullstat}`),
            request.get(`${baseUrl()}/drawings/${year}/${ekatte}/${bullstat}/sum`),
            request.get(`${baseUrl()}/companies-initial-info/${year}/${ekatte}/${bullstat}`)
        ])
            .then(([dataDeals, dataOthers, dataDrawings, dataInitialInfo]) => {
                setSumDeals(dataDeals.sum_deals);
                setSumWhiteSpots(dataOthers.white_spots || 0);
                setSumRoads(dataOthers.roads || 0);
                setSumDrawing(dataDrawings.sum_drawings);
                setSumInitialInfo(dataInitialInfo);

                // Н0: същата сметка, едно място. Тук тя изглеждаше различна —
                // без „годна" — и това НЕ беше грешка: този компонент се рисува
                // САМО за землища БЕЗ правно основание (виж `Row` по-долу:
                // връща null, щом `sumInitialInfo` има ключове), тоест годна
                // площ там няма и събираемото е нула. Общата функция дава
                // същото число, защото `val(undefined) === 0`.
                setSumForDrawing(pravno({
                    suitableLand: dataInitialInfo.suitable_land,
                    correction: dataOthers.correction,
                    sumDeals: dataDeals.sum_deals,
                    whiteSpots: dataOthers.white_spots,
                    roads: dataOthers.roads,
                    othersVal: dataOthers.others,
                    othersPlus: dataOthers.others_plus,
                }));
            })
    }, [])

    const Row = () => {
        if (sumInitialInfo) {
            if (Object.keys(sumInitialInfo).length > 0) {
                return null
            }

            const drawingDiff = sumForDrawing - sumDrawing;

            return (
                <tr>
                    <th scope="row">{ekatte}</th>
                    <td><Link style={{color: "var(--app-gold)", textDecoration: "none"}}
                              to={`/info/${year}/${ekatte}/${bullstat}`}>{settlement}</Link></td>
                    <td>{municipality}</td>
                    <td>{region}</td>
                    <td></td>
                    <td></td>
                    <td>{sumWhiteSpots ? sumWhiteSpots.toFixed(2) : null}</td>
                    <td>{sumRoads ? sumRoads.toFixed(2) : null}</td>
                    <td>{sumDeals ? sumDeals.toFixed(2) : null}</td>
                    <td>{sumForDrawing ? sumForDrawing.toFixed(2) : null}</td>
                    <td>{sumDrawing ? sumDrawing.toFixed(2) : null}</td>
                    <Status drawingDiff={drawingDiff}/>
                </tr>
            )
        }
    }

    return <Row/>
}


export const CompanySettlement1 = ({ekatte, settlement, municipality, region, bullstat}) => {
    const {year} = useParams();
    const request = requester();
    const [sumDeals, setSumDeals] = useState(0);
    const [sumWhiteSpots, setSumWhiteSpots] = useState(0);
    const [sumRoads, setSumRoads] = useState(0);
    const [sumForDrawing, setSumForDrawing] = useState(null);
    const [sumDrawing, setSumDrawing] = useState(undefined);
    const [sumInitialInfo, setSumInitialInfo] = useState(undefined);

    useEffect(() => {
        Promise.all([
            request.get(`${baseUrl()}/deals/${year}/${ekatte}/${bullstat}/sum`),
            request.get(`${baseUrl()}/others/${year}/${ekatte}/${bullstat}`),
            request.get(`${baseUrl()}/drawings/${year}/${ekatte}/${bullstat}/sum`),
            request.get(`${baseUrl()}/companies-initial-info/${year}/${ekatte}/${bullstat}`)
        ])
            .then(([dataDeals, dataOthers, dataDrawings, dataInitialInfo]) => {
                setSumDeals(dataDeals.sum_deals);
                setSumWhiteSpots(dataOthers.white_spots || 0);
                setSumRoads(dataOthers.roads || 0);
                setSumDrawing(dataDrawings.sum_drawings);
                setSumInitialInfo(dataInitialInfo);

                // Н0: сметката е ЕДНА — utils/pravno.js.
                setSumForDrawing(pravno({
                    suitableLand: dataInitialInfo.suitable_land,
                    correction: dataOthers.correction,
                    sumDeals: dataDeals.sum_deals,
                    whiteSpots: dataOthers.white_spots,
                    roads: dataOthers.roads,
                    othersVal: dataOthers.others,
                    othersPlus: dataOthers.others_plus,
                }));
            })
    }, [])

    const drawingDiff = sumForDrawing - sumDrawing;

    return (
        <tr>
            <th scope="row">{ekatte}</th>
            <td><Link style={{color: "var(--app-gold)", textDecoration: "none"}}
                      to={`/info/${year}/${ekatte}/${bullstat}`}>{settlement}</Link></td>
            <td>{municipality}</td>
            <td>{region}</td>
            <td>{sumInitialInfo ? sumInitialInfo.declared_land?.toFixed(2) : null}</td>
            <td>{sumInitialInfo ? sumInitialInfo.suitable_land?.toFixed(2) : null}</td>
            <td>{sumWhiteSpots ? sumWhiteSpots.toFixed(2) : null}</td>
            <td>{sumRoads ? sumRoads.toFixed(2) : null}</td>
            <td>{sumDeals ? sumDeals.toFixed(2) : null}</td>
            <td>{sumForDrawing ? sumForDrawing.toFixed(2) : null}</td>
            <td>{sumDrawing ? sumDrawing.toFixed(2) : null}</td>
            <Status drawingDiff={drawingDiff}/>
        </tr>
    )
}